module.exports = __webpack_public_path__ + "img/fair-new.6faebbce.svg";